import { call, put } from "redux-saga/effects";

import {
  getRESECommandDivisionDetailsSuccess,
  getRESECommandDivisionDetailsFailure,
  resepostCreateJobSuccess,
  resepostCreateJobFailure,
  getRESEJobDetailsSuccess,
  getRESEJobDetailsFailure,
  getRESEServerDetailsByJobIdSuccess,
  getRESEServerDetailsByJobIdFailure,
  cancelRESECommandScheduleSuccess,
  cancelRESECommandScheduleFailure,
} from "../components/rese/command-and-control/redux/actions";
import RESECommandService from "../components/rese/command-and-control/RESECommandService";

const reseCommandService = new RESECommandService();

/**
 * Worker saga for loading division detail in Grafana Agent Remote command Page
 */
function* loadReseCommandDivisionDetails() {
  try {
    const divisionDetail = yield call(reseCommandService.getDivisionDetail);
    yield put(getRESECommandDivisionDetailsSuccess(divisionDetail));
  } catch (error) {
    yield put(getRESECommandDivisionDetailsFailure(error.toString()));
  }
}

function* resepostCreatedJob(action) {
  try {
    const createJob = yield call(
      reseCommandService.resepostCreateJob,
      action.payload
    );
    yield put(resepostCreateJobSuccess(createJob));
  } catch (error) {
    yield put(resepostCreateJobFailure(error.toString()));
  }
}



function* reseloadJobDetails({ startDate, endDate, offset }) {
  try {
    const jobDetails = yield call(
      reseCommandService.getJobDetails,
      startDate,
      endDate,
      offset
    );
    yield put(getRESEJobDetailsSuccess(jobDetails));
  } catch (error) {
    yield put(getRESEJobDetailsFailure(error.toString()));
  }
}

function* loadReseServerDetailsByJobId({ jobId }) {
  try {
    const serverDetailsByJobId = yield call(
      reseCommandService.getServerDetailsById,
      jobId
    );
    yield put(getRESEServerDetailsByJobIdSuccess(serverDetailsByJobId));
  } catch (error) {
    yield put(getRESEServerDetailsByJobIdFailure(error.toString()));
  }
}

function* cancelReseGrafanaAgentScheduledJob({
  cancelSchedule,
  startDate,
  endDate,
  offset,
}) {
  try {
    yield call(reseCommandService.cancelJobSchedule, cancelSchedule);
    yield put(cancelRESECommandScheduleSuccess());
    try {
      const jobDetails = yield call(
        reseCommandService.getJobDetails,
        startDate,
        endDate,
        offset
      );
      yield put(getRESEJobDetailsSuccess(jobDetails));
    } catch (error) {
      yield put(getRESEJobDetailsFailure(error.toString()));
    }
  } catch (error) {
    yield put(cancelRESECommandScheduleFailure(error.toString()));
  }
}

export {
  loadReseCommandDivisionDetails,
  resepostCreatedJob,
  reseloadJobDetails,
  loadReseServerDetailsByJobId,
  cancelReseGrafanaAgentScheduledJob,
};
